(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sock-type-nav"] && !Shopify.designMode) return;
  try {
    
  const selectSockType = (root, typeId) => {
    if (!root || !typeId) return;

    root.querySelectorAll('[data-sock-type]').forEach((tab) => {
      const selected = tab.dataset.sockType === typeId;
      tab.classList.toggle('is-selected', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    root.querySelectorAll('[data-sock-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.sockPanel !== typeId;
    });
  };

  const defaultSockType = (root) =>
    root?.querySelector('[data-sock-type]')?.dataset.sockType;

  const enterShopView = (typeId) => {
    const root = document.querySelector('.sock-type-nav');
    const types = document.querySelector('[data-sock-type-types]');
    if (!root || !types) return;

    root.classList.add('is-open');
    document.documentElement.classList.add('is-shop-view');
    selectSockType(root, typeId || defaultSockType(root));
    types.scrollIntoView({ behavior: 'instant', block: 'start' });
  };

  const openShopFromHash = () => {
    if (window.location.hash === '#shop') enterShopView();
  };

  const getProductModal = () => document.querySelector('[data-sock-modal]');
  const getProductModalBody = () => document.querySelector('[data-sock-modal-body]');
  const getModalSlides = () => [...(getProductModalBody()?.querySelectorAll('[data-sock-modal-slide]') || [])];

  const setModalSlide = (index) => {
    const slides = getModalSlides();
    if (!slides.length) return;

    const next = Math.min(Math.max(index, 0), slides.length - 1);
    slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== next;
    });

    const modal = getProductModal();
    const prev = modal?.querySelector('[data-sock-modal-prev]');
    const forward = modal?.querySelector('[data-sock-modal-next]');
    const onlyOne = slides.length < 2;

    if (prev) {
      prev.hidden = onlyOne;
      prev.disabled = onlyOne || next === 0;
    }

    if (forward) {
      forward.hidden = onlyOne;
      forward.disabled = onlyOne || next === slides.length - 1;
    }
  };

  const stepModalSlide = (delta) => {
    const slides = getModalSlides();
    if (slides.length < 2) return;
    const current = Math.max(0, slides.findIndex((slide) => !slide.hidden));
    const next = current + delta;
    if (next < 0 || next >= slides.length) return;
    setModalSlide(next);
  };

  const closeProductModal = () => {
    const modal = getProductModal();
    if (!modal?.open) return;
    modal.close();
    const modalBody = getProductModalBody();
    if (modalBody) modalBody.innerHTML = '';
    document.body.style.removeProperty('overflow');
  };

  const openProductModal = (trigger) => {
    const modal = getProductModal();
    const modalBody = getProductModalBody();
    if (!modal || !modalBody) return;

    const images = trigger.closest('.sock-type-nav__product')?.querySelector('[data-sock-modal-images]');
    if (!images) return;

    modalBody.replaceChildren(images.content.cloneNode(true));
    setModalSlide(0);
    modal.showModal();
    document.body.style.overflow = 'hidden';
  };

  const getSockQtyInput = (actions) =>
    actions.closest('.sock-type-nav__order')?.querySelector('[data-sock-qty-input]');

  const getSockButton = (actions) => actions.querySelector('[data-sock-cart-button]');

  const getSockEditControls = (actions) => ({
    edit: actions.querySelector('[data-sock-edit-cart]'),
    cancel: actions.querySelector('[data-sock-cancel-edit]'),
    remove: actions.querySelector('[data-sock-remove-cart]'),
    confirm: actions.querySelector('[data-sock-confirm-edit]'),
  });

  const setSockButton = (button, { type, label, added }) => {
    if (!button) return;
    const text = button.querySelector('[data-sock-cart-label]');
    button.type = type;
    if (text) text.textContent = label;
    else button.textContent = label;
    button.disabled = Boolean(button.dataset.soldOut);
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.classList.toggle('is-added', Boolean(added));
  };

  const setSockLoading = (actions, loading) => {
    const button = getSockButton(actions);
    if (!button || button.dataset.soldOut) return;
    const text = button.querySelector('[data-sock-cart-label]');
    button.classList.toggle('is-loading', loading);
    button.toggleAttribute('aria-busy', loading);
    button.disabled = loading;
    if (text && loading) text.textContent = 'Adding';
  };

  const setSockEditMode = (actions, editing) => {
    const { edit, cancel, remove, confirm } = getSockEditControls(actions);
    const inCart = Number(actions.dataset.sockCartQty || 0) > 0;
    if (edit) edit.hidden = editing || !inCart;
    [cancel, remove, confirm].forEach((control) => {
      if (!control) return;
      control.hidden = !editing;
      control.disabled = false;
    });
  };

  const setSockCartState = (actions, inCart, quantity, lineKey) => {
    if (!actions) return;
    const form = actions.closest('.sock-type-nav__order');
    const button = getSockButton(actions);
    const input = getSockQtyInput(actions);
    form?.classList.toggle('is-in-cart', inCart);
    form?.classList.remove('is-editing');
    actions.dataset.sockCartQty = String(quantity || 0);
    if (lineKey) actions.dataset.sockLineKey = lineKey;
    if (!inCart) delete actions.dataset.sockLineKey;
    if (button && !button.dataset.soldOut) {
      setSockButton(button, {
        type: inCart ? 'button' : 'submit',
        label: inCart ? 'Added to cart' : 'Add to cart',
        added: inCart,
      });
    }
    setSockEditMode(actions, false);
    if (input) input.value = String(quantity > 0 ? quantity : input.min || 1);
  };

  const enterSockEdit = (actions) => {
    const form = actions.closest('.sock-type-nav__order');
    const input = getSockQtyInput(actions);
    form?.classList.add('is-in-cart', 'is-editing');
    if (input) input.value = actions.dataset.sockCartQty || input.value || '1';
    setSockEditMode(actions, true);
  };

  const cancelSockEdit = (actions) => {
    const input = getSockQtyInput(actions);
    const quantity = Number(actions.dataset.sockCartQty || 0);
    if (input) input.value = String(quantity || input.min || 1);
    setSockCartState(actions, quantity > 0, quantity, actions.dataset.sockLineKey);
  };

  const getCartSectionIds = () =>
    Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

  const dispatchSockCartLinesUpdate = (actions, action) => {
    let resolvePromise = () => {};
    let rejectPromise = () => {};
    const promise = new Promise((resolve, reject) => {
      resolvePromise = resolve;
      rejectPromise = reject;
    });

    const event = new CustomEvent('shopify:cart:lines-update', {
      bubbles: true,
      cancelable: true,
    });
    event.action = action;
    event.promise = promise;
    actions.dispatchEvent(event);

    return { resolvePromise, rejectPromise };
  };

  const updateSockCart = (actions, nextQuantity) => {
    const input = getSockQtyInput(actions);
    const { cancel, remove, confirm } = getSockEditControls(actions);
    const variantId = actions.dataset.sockVariant;
    const lineKey = actions.dataset.sockLineKey;
    const quantity = nextQuantity == null ? Number(input?.value || 0) : Number(nextQuantity);
    if (!variantId) return;

    [cancel, remove, confirm].forEach((control) => {
      if (control) control.disabled = true;
    });

    const { resolvePromise, rejectPromise } = dispatchSockCartLinesUpdate(
      actions,
      quantity > 0 ? 'update' : 'remove'
    );

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey || Number(variantId),
        quantity,
        sections: getCartSectionIds().join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.errors || cart.status) {
          rejectPromise(new Error(cart.errors || cart.message || 'Cart update failed'));
          setSockEditMode(actions, true);
          return;
        }

        const item = (cart.items || []).find((line) => String(line.variant_id) === String(variantId));
        setSockCartState(actions, Boolean(item && item.quantity > 0), item?.quantity || 0, item?.key);
        resolvePromise({
          cart: { totalQuantity: cart.item_count },
          detail: {
            sections: cart.sections,
            items: cart.items,
            itemCount: cart.item_count,
            source: 'sock-type-nav',
            didError: false,
          },
        });
      })
      .catch((error) => {
        rejectPromise(error);
        setSockEditMode(actions, true);
      });
  };

  const applyCartItems = (items) => {
    document.querySelectorAll('[data-sock-actions]').forEach((actions) => {
      const variantId = actions.dataset.sockVariant;
      const item = (items || []).find((line) => String(line.variant_id) === String(variantId) && Number(line.quantity) > 0);
      setSockCartState(actions, Boolean(item), item?.quantity || 0, item?.key);
    });
  };

  const syncSockCartFromServer = (actions) =>
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        if (actions) {
          const item = (cart.items || []).find(
            (line) => String(line.variant_id) === String(actions.dataset.sockVariant) && Number(line.quantity) > 0
          );
          setSockCartState(actions, Boolean(item), item?.quantity || 0, item?.key);
          return;
        }
        applyCartItems(cart.items);
      });

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const productForm = event.target instanceof Element ? event.target.closest('product-form-component') : null;
    const actions = productForm?.querySelector('[data-sock-actions]');

    if (event.action === 'add' && actions) setSockLoading(actions, true);

    if (!event.promise) {
      if (actions && event.action === 'add') syncSockCartFromServer(actions);
      return;
    }

    event.promise
      .then(({ detail }) => {
        if (detail?.didError && actions && event.action === 'add') {
          setSockCartState(actions, false, 0);
          return;
        }

        if (event.action === 'add' && Array.isArray(detail?.items)) {
          const item = detail.items.find(
            (line) => String(line.variant_id) === String(actions?.dataset.sockVariant) && Number(line.quantity) > 0
          );
          if (item && actions) {
            setSockCartState(actions, true, item.quantity, item.key);
            return;
          }
        }

        return syncSockCartFromServer(actions);
      })
      .catch(() => syncSockCartFromServer(actions));
  });

  document.addEventListener('click', (event) => {
    const shop = event.target.closest('[data-sock-type-shop]');
    if (shop) {
      const root = shop.closest('.sock-type-nav');
      const types = root?.querySelector('[data-sock-type-types]');
      if (!types) return;

      event.preventDefault();
      root.classList.add('is-open');
      selectSockType(root, defaultSockType(root));
      types.scrollIntoView({ behavior: 'smooth', block: 'start' });

      let settled = false;
      const settle = () => {
        if (settled) return;
        settled = true;
        enterShopView(defaultSockType(root));
        if (window.location.hash !== '#shop') {
          history.pushState({ shopView: true }, '', '#shop');
        }
      };

      document.addEventListener('scrollend', settle, { once: true });
      setTimeout(settle, 600);
      return;
    }

    if (event.target.closest('[data-sock-modal-prev]')) {
      event.preventDefault();
      stepModalSlide(-1);
      return;
    }

    if (event.target.closest('[data-sock-modal-next]')) {
      event.preventDefault();
      stepModalSlide(1);
      return;
    }

    const editCart = event.target.closest('[data-sock-edit-cart]');
    if (editCart) {
      event.preventDefault();
      const actions = editCart.closest('[data-sock-actions]');
      if (actions) enterSockEdit(actions);
      return;
    }

    const cancelEdit = event.target.closest('[data-sock-cancel-edit]');
    if (cancelEdit) {
      event.preventDefault();
      const actions = cancelEdit.closest('[data-sock-actions]');
      if (actions) cancelSockEdit(actions);
      return;
    }

    const removeCart = event.target.closest('[data-sock-remove-cart]');
    if (removeCart) {
      event.preventDefault();
      const actions = removeCart.closest('[data-sock-actions]');
      if (actions) updateSockCart(actions, 0);
      return;
    }

    const confirmEdit = event.target.closest('[data-sock-confirm-edit]');
    if (confirmEdit) {
      event.preventDefault();
      const actions = confirmEdit.closest('[data-sock-actions]');
      if (actions) updateSockCart(actions);
      return;
    }

    const qtyButton = event.target.closest('[data-sock-qty-minus], [data-sock-qty-plus]');
    if (qtyButton) {
      event.preventDefault();
      const wrap = qtyButton.closest('[data-sock-qty]');
      const input = wrap?.querySelector('[data-sock-qty-input]');
      if (!input) return;

      const step = Number(input.step || 1);
      const editing = Boolean(qtyButton.closest('.sock-type-nav__order.is-editing'));
      const min = editing ? 0 : Number(input.min || 1);
      const max = input.max === '' ? Infinity : Number(input.max);
      const next = Number(input.value || min) + (qtyButton.hasAttribute('data-sock-qty-plus') ? step : -step);
      input.value = Math.min(max, Math.max(min, next));
      return;
    }

    if (event.target.closest('[data-sock-close-modal]')) {
      event.preventDefault();
      closeProductModal();
      return;
    }

    if (event.target === getProductModal()) {
      closeProductModal();
      return;
    }

    const openModal = event.target.closest('[data-sock-open-modal]');
    if (openModal) {
      event.preventDefault();
      openProductModal(openModal);
      return;
    }

    const tab = event.target.closest('[data-sock-type]');
    if (!tab) return;

    event.preventDefault();
    selectSockType(tab.closest('.sock-type-nav'), tab.dataset.sockType);
  });

  document.addEventListener('keydown', (event) => {
    if (!getProductModal()?.open) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      stepModalSlide(-1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      stepModalSlide(1);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target !== getProductModal()) return;
    const modalBody = getProductModalBody();
    if (modalBody) modalBody.innerHTML = '';
    document.body.style.removeProperty('overflow');
  }, true);

  window.addEventListener('popstate', () => {
    if (window.location.hash === '#shop') {
      enterShopView();
      return;
    }

    document.documentElement.classList.remove('is-shop-view');
    document.querySelector('.sock-type-nav')?.classList.remove('is-open');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openShopFromHash, { once: true });
  } else {
    openShopFromHash();
  }

  } catch(e) { console.error(e); }
})();
})();
